module.exports = __webpack_public_path__ + "img/t4.8e323080.png";